// extracted by mini-css-extract-plugin
module.exports = {"body":"_2a72TB","close":"_2imKva","message":"_2L0cpC","actions":"djwgjv"};